// Externe Bibliotheken
import React, { Component } from 'react';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import StatusPage from '@/comp/statusPage/statusPage';

// Interne Module
import { getSearchParams } from '@/_helper/searchParamsHelper';

class BookingFailed extends Component {
    searchParams;
    subPage;

    constructor(props) {
        super(props);

        this.searchParams = getSearchParams();

        switch (this.searchParams && this.searchParams.page && this.searchParams.page[0]) {
            case 'seatReservation':
            case 'excursion':
            case 'transfer':
            case 'insurance':
            case 'railAndFly':
                this.subPage = 'booking-' + this.searchParams['page'][0];
                break;
            default:
                this.subPage = 'booking';
                break;
        }
    }

    render() {
        return (
            <div className="page-booking-failed">
                <Header />
                <StatusPage type="error" subPage={this.subPage} />
                <Footer />
            </div>
        );
    }
}

export default BookingFailed;
